module.exports = __webpack_public_path__ + "static/media/ios-heart-empty.62676aa5.svg";